import { Modal, Space, Form, Input, Divider, message, Image } from "antd";
import React, { useState, useEffect } from "react";
import { uploadFile, updateFlow } from "@/services/common";
import { UploadOutlined } from "@ant-design/icons";
import { radomPics } from "@/config/const";

type FieldType = {
  name: string;
  description?: string;
  // owner_id: number;
  thumbnail_url?: string | null;
};

const Component = (props: any) => {
  const { status, setStatus, userInfo, loadData, source } = props;
  const [coverImg, setCoverImg] = useState<string | null>(null);
  const [form] = Form.useForm();

  const closeModal = () => {
    setStatus(false);
  };

  console.log(source);

  useEffect(() => {
    form.setFieldsValue({
      name: source.name,
      description: source.description,
    });
    setCoverImg(source.thumbnail_url);
  }, [status]);

  const upFile = async (e: any) => {
    const file = e.target.files[0];
    // setCurFile(file);
    // console.log(file);
    if (file.type === "image/gif" || file.type === "image/png" || file.type === "image/jpeg") {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadFile(formData, userInfo.access_token);
      const s = await res.json();
      // console.log(s);
      setCoverImg(s.fileUrl);
    } else {
      message.info("只允许上传图片文件，请重新上传！");
    }

    // console.log(s);
    // if (s.status === 200) {
    //   // const mol = await getMolInfo(formData);
    //   // const molJson = await mol.json();
    //   // console.log('molJson',molJson);
    //   // setMolInfo(molJson.data);
    //   // setCurModelUrl(s.data.url);
    // } else {
    //   message.error('文件上传失败！')
    // }
  };

  const onFinish = (values: FieldType) => {
    const subData = {
      ...values,
      thumbnail_url: coverImg ? coverImg : null,
      // flow_data_url: "https://devindata-files.oss-cn-qingdao.aliyuncs.com/industrial-computing-platform/flow_48_20250508_060750.json"
    };
    updateFlow(source.project_id, source.id, subData, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        closeModal();
        message.success("流程修改成功！");
        loadData();
      } else {
        message.error("流程修改失败！");
      }
    });

    console.log("subData", subData);
  };

  // const radom_thumbnail = async () => {
  //   const filePath = radomPics();
  //   setCoverImg(filePath);
  // };

  return (
    <Modal
      title={
        <Space>
          <div className="t2">{`修改流程信息`}：</div>
        </Space>
      }
      open={status}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
      maskClosable={false}
      destroyOnHidden={true}
      width="55%"
      // afterOpenChange={()=>{

      // }}
      // closeIcon={<CloseCircleFilled style={{ color: '#FFF' }} />}
      //     okText: '确认',
      // cancelText: '取消',
      style={{ top: 40 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "5rem",
        }}
      >
        <Form
          name="createProject"
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 18 }}
          style={{ width: "70%" }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={<div className="t3">流程名称</div>}
            name="name"
            rules={[{ required: true, message: "请输入流程名称!" }]}
          >
            <Input size="large" style={{ borderRadius: 0 }} />
          </Form.Item>
          {coverImg ?
            <Form.Item
              label={<div className="t3">流程缩略图</div>}
            // name="description"
            // rules={[{ required: true, message: '请输入项目名称!' }]}
            >
              <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.2)"}}>
                <Image src={coverImg} width="100%" />
              </div>
            </Form.Item>
            : ''}
          <Form.Item
            label={<div className="t3">流程描述</div>}
            name="description"
          // rules={[{ required: true, message: '请输入项目名称!' }]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>

          <Divider />
          <Form.Item wrapperCol={{ offset: 4, span: 18 }}>
            <Space>
              <div className="button_new" onClick={() => form.submit()}>
                确定修改
              </div>
              <div className="button_cancle_new" onClick={closeModal}>
                关闭
              </div>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default Component;
